import { API_URL } from "../constants";

export const GET_COMPONENT = (idType: any, idBrand: any) => `${API_URL}component/public/byIdTipoAndBrand/${idType}/${idBrand}/`